export default __webpack_public_path__ + "static/AeonikPro-Regular-691efc19af99e9b807b431be564f11a2.woff";